export const getBaseUrl = () => {
  // if (import.meta.env.DEV) {
  //   Development: use Vite proxy to avoid certificate issues
  //   const { protocol, hostname, port } = window.location;
  //   return `${protocol}//${hostname}:${port}/api`;
  // }
  // Production: use hardcoded IP
  // return `https://192.168.1.4:5017`;

  // In both dev and prod, call the API via same origin through /api
  if (typeof window !== 'undefined' && window.location) {
    return `${window.location.origin}/api`;
  }
  // Fallback for SSR or edge cases
  return '/api';
};
